import { gql } from 'glimmer-apollo';

export const ESPORTS_LATEST_MATCH_QUERY = gql`
  query EsportsLatestMatch {
    matches(
      filter: { 
        isLive: false
      }
      limit: 1
    ) {
      id
      title
      name
      slug
      scheduledDate
      isFinal
      isLive
      bestOf
      tournament {
        id
        name
        title
        slug
        game {
          title
          slug
        }
      }
      teams {
        id
        name
        slug
        country
        logo {
          url(width: 96, height: 96, fit: cover, format: webp)
        }
      }
      victor {
        id
        slug
        name
      }
      rounds {
        id
        roundNumber
        victor {
          slug
        }
      }
    }
  }
`;
